import { Link } from "react-router-dom";

export function Footer() {
  return <footer className="site-footer"><div className="site-shell site-footer-inner"><p>FTM is public market intelligence, not a betting or trade-execution service.</p><div className="site-footer-links"><Link to="/methodology">Methodology</Link><Link to="/archive">Report Archive</Link><Link to="/pro">Founding Pro</Link></div></div></footer>;
}
